import React, { useState, useRef } from 'react';
import '../styles/ContactCard.css'; // Import the dedicated CSS file
import ThankYouModal from './ThankYouModal';
import { saveEnquiry } from '../functions/Enquiry';

const ContactCard = ({ isOverlay = false, isHero = false, whiteText = false, onClose, hideLabels = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    travellerCount: '',
    travelDate: '',
    message: '',
  });

  const [step, setStep] = useState(1); // 1 = form, 2 = thank you
  const [submitting, setSubmitting] = useState(false); // spinner state
  const formRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    // Save enquiry to Firestore
    await saveEnquiry({
      contactInfo: {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
      },
      travellerCount: formData.travellerCount,
      travelDate: formData.travelDate,
      message: formData.message,
    });

    if (formRef.current) {
      formRef.current.target = '';
      if (!document.getElementById('hidden-formsubmit-frame')) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.name = 'hidden-formsubmit-frame';
        iframe.id = 'hidden-formsubmit-frame';
        document.body.appendChild(iframe);
      }
      formRef.current.target = 'hidden-formsubmit-frame';
      formRef.current.submit();
    }

    setFormData({ name: '', email: '', phone: '', travellerCount: '', travelDate: '', message: '' });
    setStep(2); // Move to thank you step
    setSubmitting(false);
  };

  // Determine which class to use based on props
  const cardClasses = `contact-card ${isOverlay ? 'contact-card-overlay-style' : ''} ${isHero ? 'contact-card-hero-style' : ''}`;
  const headingClasses = `contact-card-heading ${isHero ? 'contact-card-heading-hero' : ''} ${whiteText ? 'contact-card-heading-white' : ''}`;

  return (
    <>
      <div className={cardClasses}>
        {(isOverlay || isHero) && (
          <button 
            className="contact-card-internal-close-button" 
            onClick={onClose}
            aria-label="Close contact form"
          >
            ✕
          </button>
        )}
        
        {!isOverlay && !isHero && (
          <h2 className="contact-card-title">Contact Us</h2>
        )}
        
        {(isOverlay || isHero) && (
          <h3 className={headingClasses}>Connect with an Expert</h3>
        )}

        {/* Step 1: Show form, Step 2: Show ThankYouModal */}
        {step === 1 && (
          <>
            <form
              ref={formRef}
              action="https://formsubmit.co/cse.officialwasim@gmail.com "
              method="POST"
              target="_blank"
              style={{ display: 'none' }}
            >
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="name" value={formData.name} />
              <input type="hidden" name="email" value={formData.email} />
              <input type="hidden" name="phone" value={formData.phone} />
              <input type="hidden" name="travellerCount" value={formData.travellerCount} />
              <input type="hidden" name="travelDate" value={formData.travelDate} />
              <input type="hidden" name="message" value={formData.message} />
              <input type="hidden" name="_captcha" value="false" />
            </form>
            
            <form onSubmit={handleSubmit} className="contact-card-form">
              <div className="contact-form-row">
                <div className="contact-form-group">
                  {!hideLabels && (
                    <label htmlFor="name" className="contact-form-label">
                      Full Name <span style={{color:'red'}}>*</span>
                    </label>
                  )}
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="contact-form-input"
                    placeholder="Your full name"
                  />
                </div>
                <div className="contact-form-group">
                  {!hideLabels && (
                    <label htmlFor="email" className="contact-form-label">
                      Email <span style={{color:'red'}}>*</span>
                    </label>
                  )}
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="contact-form-input"
                    placeholder="you@email.com"
                  />
                </div>
              </div>
              
              <div className="contact-form-group">
                {!hideLabels && (
                  <label htmlFor="phone" className="contact-form-label">
                    Phone <span style={{color:'red'}}>*</span>
                  </label>
                )}
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="contact-form-input"
                  placeholder="Your phone number"
                  pattern="[0-9]{10}"
                  title="Please enter a 10-digit phone number"
                />
              </div>
              
              <div className="contact-form-row">
                <div className="contact-form-group">
                  {!hideLabels && (
                    <label htmlFor="travellerCount" className="contact-form-label">
                      Traveller Count <span style={{color:'red'}}>*</span>
                    </label>
                  )}
                  <input
                    type="number"
                    id="travellerCount"
                    name="travellerCount"
                    value={formData.travellerCount}
                    onChange={handleChange}
                    required
                    min="1"
                    className="contact-form-input"
                    placeholder="Number of travellers"
                  />
                </div>
                <div className="contact-form-group">
                  {!hideLabels && (
                    <label htmlFor="travelDate" className="contact-form-label">
                      Travel Date <span style={{color:'red'}}>*</span>
                    </label>
                  )}
                  <input
                    type="date"
                    id="travelDate"
                    name="travelDate"
                    value={formData.travelDate}
                    onChange={handleChange}
                    required
                    className="contact-form-input"
                  />
                </div>
              </div>
              
              <div className="contact-form-group">
                {!hideLabels && (
                  <label htmlFor="message" className="contact-form-label">
                    Message
                  </label>
                )}
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="contact-form-textarea"
                  placeholder="Tell us about your travel plans..."
                />
              </div>
              
              <button type="submit" className="contact-form-button" disabled={submitting}>
                {submitting && (
                  <span
                    style={{
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginRight: 8,
                      width: 18,
                      height: 18,
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 50 50"
                      style={{ display: 'block' }}
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="5"
                        strokeDasharray="31.4 31.4"
                        strokeLinecap="round"
                        transform="rotate(-90 25 25)"
                      >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 25 25"
                          to="360 25 25"
                          dur="1s"
                          repeatCount="indefinite"
                        />
                      </circle>
                    </svg>
                  </span>
                )}
                {submitting ? 'Sending...' : 'Send Enquiry'}
              </button>
            </form>
          </>
        )}

        {step === 2 && (
          <ThankYouModal
            isOpen={true}
            onClose={() => {
              setStep(1);
              if (onClose) onClose();
            }}
            userInfo={{ name: formData.name }}
            inline={isOverlay || isHero}
          />
        )}
      </div>
    </>
  );
};

export default ContactCard;